export default __webpack_public_path__ + "static/media/discord.9e296800.ico";